export default __webpack_public_path__ + "static/MineralSwimV2_NEW-Box-12174919dc1d5156586ef96cbf9ef4e3.png";